import { useId, type ReactNode } from "react";
import "./DashboardLedger.css";

export interface DashboardSectionProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  labelledBy?: string;
}

export function DashboardSection({
  title,
  action,
  children,
  className,
  labelledBy,
}: DashboardSectionProps) {
  const generatedId = useId();
  const titleId = labelledBy ?? `dashboard-ledger-section-${generatedId}`;
  return (
    <section
      className={`dashboard-ledger dashboard-ledger-section${className ? ` ${className}` : ""}`}
      aria-labelledby={titleId}
    >
      <header className="dashboard-ledger-section__header">
        <h2 id={titleId} className="dashboard-ledger-section__title">
          {title}
        </h2>
        {action ? (
          <div className="dashboard-ledger-section__action">{action}</div>
        ) : null}
      </header>
      <div className="dashboard-ledger-section__body">{children}</div>
    </section>
  );
}
